import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
    AGENCY_CONTEXT_HEADER,
    AGENCY_CONTEXT_INVALID,
    AgencyContextService,
} from '../services/agency-context.service';

const READ_METHODS = ['GET', 'HEAD'];

/**
 * Contexto global de agência do MASTER: junta o cabeçalho aos pedidos à API
 * e impede que uma leitura iniciada antes de trocar de agência entregue
 * dados da agência anterior.
 *
 * Registado DEPOIS do JwtInterceptor: assim recebe o erro HTTP original (o
 * JwtInterceptor transforma-o em texto) e a repetição após o refresh do token
 * volta a passar por aqui, já com a agência atual.
 */
@Injectable()
export class AgencyContextInterceptor implements HttpInterceptor {
    constructor(private readonly agencyContext: AgencyContextService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.indexOf(environment.apiUrl) !== 0) {
            return next.handle(req);
        }

        const storeId = this.agencyContext.storeId;
        const request = storeId
            ? req.clone({ setHeaders: { [AGENCY_CONTEXT_HEADER]: `${storeId}` } })
            : req;

        let handled = next.handle(request).pipe(
            catchError((err) => {
                if (
                    err instanceof HttpErrorResponse &&
                    err.status === 403 &&
                    err.error?.message === AGENCY_CONTEXT_INVALID
                ) {
                    this.agencyContext.handleInvalid();
                }
                return throwError(err);
            })
        );

        // Só as leituras são canceladas: uma gravação em curso tem de chegar
        // ao fim e o ecrã tem de saber o resultado.
        if (READ_METHODS.includes(req.method?.toUpperCase())) {
            handled = handled.pipe(takeUntil(this.agencyContext.changed$));
        }

        return handled;
    }
}
